/*
Dexie Fehler: Connection to Indexed Database server lost. Refresh the page to try again↵ UnknownError: Connection to Indexed Database server lost…
https://github.com/dexie/Dexie.js/issues/2008
https://bugs.webkit.org/show_bug.cgi?id=201483
*/


import Dexie from 'dexie';

const db = new Dexie('forsales');

db.version(1).stores({
    pdf: '&id, container',
    image: '&id, container',
    video: '&id, container, name',
    json: '&id, container, name',
    portfolio: '&id, container, name'
});

export default db;